<template>
  <div id="rate" style="height:100%; width: 100%">
<el-container>
  <el-header  style="height:15%;">
        <el-select
          v-model="selectedBU"
          style="right: -20px"
          placeholder="所有BU"
          @change="refreshPlantList()"
        >
          <el-option
            v-for="item in BUList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      
        <el-select
          id="selectedPlant"
          v-model="selectedPlant"
          multiple
          filterable
          clearable
          placeholder="所有工厂"
        >
          <el-option
            v-for="item in PlantList"
            :key="item.PlantCode"
            :label="item.PlantName"
            :value="item.PlantCode"
          ></el-option>
        </el-select>

        <el-button-group>
          <el-button
            :type="activeChartGroup == 'chart' ? 'primary' : 'success'"
            plain
            :disabled="activeChartGroup == 'chart'"
            icon="el-icon-s-data"
            @click="onChartGroupChanged('chart')"
          ></el-button>
          <el-button
            :type="activeChartGroup == 'table' ? 'primary' : 'success'"
            plain
            :disabled="activeChartGroup == 'table'"
            icon="el-icon-s-grid"
            @click="onChartGroupChanged('table')"
          ></el-button>                                                                                                                                 
          <el-button
            :type="activeChartGroup == 'detail' ? 'primary' : 'success'"
            plain
            :disabled="activeChartGroup == 'detail'"
            icon="el-icon-document"
            @click="onChartGroupChanged('detail')"
          ></el-button>
        </el-button-group>
  
     <el-date-picker
          v-model="selectedDateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
       <el-input
          v-model="FilterNumber"
          style="width: 80px"
          placeholder="前N"
        ></el-input>
        <el-button type="success" plain @click="loadDataList()"
          >查询</el-button
        >
  </el-header>
  <el-main style="backgroup-color:red">
      <div id="myChart" style="height:900px; width: 100%;padding:10px"></div>
</el-main>
</el-container>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from "echarts";
import topHeader from "../TopMenu/topHeader.vue";
import request from "@/utils/request";
import { AREA_LIST, BU_LIST } from "../mainPage/area_bu";
export default {
  name: "rate",
  data() {
    return {
        activeName: "first",
      PageTitle: "搪塑线对标",
      DataList: {},
      PlantList: [],
      AreaList: AREA_LIST,
      BUList: BU_LIST,
      selectedArea: "GLOBAL",
      selectedBU: "",
      selectedPlant: "",
      selectedBranch: "",
      selectedTon: "",
      selectedEquipment: "",
      selectedDateRange: "",
      selectedFilterBy: "",
      activeChartGroup: "chart",
      activeCategory: "rate",
      activeColumnGroup: "energy",
      selectedFilterOrder: "desc",
      FilterNumber: "10",
       FilterListCategory: {
        kpi: [
          { value: "kpi_minute", label: "分钟单耗" },
          { value: "kpi_kg", label: "公斤单耗" },
          { value: "kpi_mold", label: "模单耗" },
        ],
        rate: [
          { value: "rate_cost", label: "能源利用率" },
          { value: "rate_time", label: "时间利用率" },
        ],
        pvf: [
          { value: "pvf_peak", label: "峰时占比" },
          { value: "pvf_flat", label: "平时占比" },
          { value: "pvf_valley", label: "谷时占比" },
          { value: "pvf_avg_cost", label: "均价" },
        ],
      },
      FilterOrder: [
        { value: "desc", label: "从大到小" },
        { value: "asc", label: "从小到大" },
      ],
      // 需要合并对象，样式
      legendColor: false,
      mm: 5,
      dataset: [
        [0.0341, 0.0491, 0.0297, 0.0287, 0.0227],
        [0.0277, 0.0412, 0.0401, 0.027, 0.0194],
      ],
      dataLabel: ["HT101", "HT102", "HT103", "HT104", "HT105"],
      equipDesc: [],
      AvgEnergyRate: 0,
      AvgTimeRate: 0,
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
       const { loadDataList, refreshDataOnChange, refreshPlantList } = this;
    var day1 = new Date()
    day1.setDate(1)
    var day2 = new Date()
    //day2.setTime(day2.getTime()-24*60*60*1000)
    this.selectedDateRange = [day1, day2]

    this.selectedFilterBy = this.FilterListCategory[this.activeCategory][0].value
    loadDataList()
  },
  methods: {
     refreshPlantList() {
      const { loadDataList, refreshDataOnChange } = this;

      let selBu = ''
      if (this.selectedBU !== undefined && this.selectedBU !== '') {
        //selBu = this.selectedBU.join()
        selBu = this.selectedBU
      }
      const queryArgs = { QueryAreaName: this.selectedArea, QueryBU: selBu, QueryFilterBy: 'IsUpload' }
      request({
        url: 'Kanban/PlantList',
        method: 'post',
        data: queryArgs
      }).then(response => {
        const res = response
        console.log(res)
        this.PlantList = res.data.Data.PlantList
      })
    },
    //加载数据
   loadDataList() {
      const { formatDate } = this;

      let selBu = ''
      if (this.selectedBU !== undefined && this.selectedBU !== '') {
        //selBu = this.selectedBU.join()
        selBu = this.selectedBU
      }
      let selPlant = ''
      if (this.selectedPlant !== undefined && this.selectedPlant !== '') {
        selPlant = this.selectedPlant.join()
      }
      let selEquip = ''
      if (this.selectedEquipment !== undefined && this.selectedEquipment !== '') {
        selEquip = this.selectedEquipment.join()
      }
      const queryArgs = {
        QueryAreaName: this.selectedArea, 
        QueryBU: selBu, 
        QueryPlantCode: selPlant,
        QueryManufacturerType: this.selectedBranch,
        QueryTonnageType: this.selectedTon,
        QueryEquipment: selEquip,
        QueryFilterBy: this.selectedFilterBy,
        QueryOrderAsc: this.selectedFilterOrder,
        QueryFilterOrder: this.FilterNumber,
        QueryDataCategory: this.activeCategory,
        QueryDetailData: (this.activeChartGroup == 'detail' ? 'Y' : '')
      }
      if (this.selectedDateRange != undefined && this.selectedDateRange.length > 1) {
        queryArgs.QueryStartMonth = formatDate(this.selectedDateRange[0])
        queryArgs.QueryEndMonth = formatDate(this.selectedDateRange[1])
      }

      request({
        url: 'Kanban/plasticining_DataList',
        method: 'post',
        data: queryArgs
      }).then(response => {
        const res = response
        this.DataList = res.data.Data
         console.log("搪塑数据",res.data)
         console.log("搪塑数据2",response)
         console.log("搪塑数据3",this.DataList)
           this.loadUpData(this.DataList);
         
      })
    },
   formatDate(date) {
      var y = date.getFullYear();
      var m = (date.getMonth() + 1);
      if (m < 10)
          m = "0" + m;
      var d = date.getDate();
      if (d < 10)
          d = "0" + d;
      var s = y + "-" + m + "-" + d;
      return s;
    },
  loadUpData(va){
    var that = this;
       var data = va;
      var data1 = [];
      var data2 = [];
      var data3 = [];
      console.log("this",data);
      const serColors = ['#008B45', '#1E90FF', '#8E8E38', '#6aa36a']
      var ls = data[0].pldb;
      var ma = data[0].aa;
      var mb = data[0].bb;
      for(var i =0; i<ls.length;i++){
      data1.push(ls[i].Key);
      data2.push(ls[i].value);
      data3.push(ls[i].dataVal);
      }
      console.log("data1",data1);
      console.log("data2",data2);
      console.log("data3",data3);
      console.log("ma",ma);
      console.log("mb",mb);


       var option = {
        title: {
          text: '搪塑机设备利用率(%)',
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          left: 'center'
        },
        legend: {
          data: ['能源利用率', '时间利用率'],
          x: 'right',
          y: '11',
          textStyle: {
            color: '#fff',
            fontSize: 16
          }
        },
        // tooltip: {
        //   trigger: 'axis',
        //   axisPointer: {
        //     type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        //   },
        //   formatter: function(params) {
        //     var str = '';
        //     str += params[0].name;
        //     str += '<br/>' + that.equipDesc[params[0].dataIndex]
        //     str += '<br/>'
        //     var now = new Date();
        //     for (var i = 0; i < params.length; i++) {
        //       str += '<br/>' + params[i].seriesName + ':' + params[i].value;
        //     }
        //     return str;
        //   }
        // },
        grid: {
          left: '6%',
          bottom: 50,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: data1,
            axisTick: {
              alignWithLabel: true,
              interval: 0
            },
            axisLabel: {
              interval: 0,
              color: '#fff',
              fontSize: 16
            },
            axisLine: {
              // 轴线
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '%',
            nameTextStyle: {
              color: '#fff',
              fontSize: 16
            },
            boundaryGap: [0, '10%'],
            min: 0,
            max: 100,
            axisLabel: {
              color: '#fff',
              fontSize: 16
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        series: [
          {
            name: '能源利用率',
            type: 'bar',
            color: serColors[0],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#fff',
                    fontSize: 14
                  }
                }
              }
            },
            data: data2,
            markLine: {
              symbol: 'none',
              data: [
                {
                  name: '平均线',
                  yAxis: ma
                }
              ],
              label: {
                normal: {
                  show: true,
                  fontSize: 18,
                  formatter: '能源利用率平均:' + ma,
                },
              },
            },
            label: {
              color: '#eee'
            }
          },
          {
            name: '时间利用率',
            type: 'bar',
            color: serColors[1],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#fff',
                    fontSize: 14
                  }
                }
              }
            },
            data: data3,
            markLine: {
              symbol: 'none',
              data: [
                {
                  name: '平均线',
                  yAxis: mb
                }
              ],
              label: {
                normal: {
                  show: true,
                  fontSize: 18,
                  formatter: '时间利用率平均:' + mb,
                },
              },
            }
          }
        ]
      };
      var myChart = echarts.init(document.getElementById('myChart'));
      myChart.setOption(option);

  },
  },
};
</script>

<style lang="less" scoped >
#rate {
  position: relative;
  width: 100%;
    background-color: #1B2445;
  height: 100%;
  box-sizing: border-box;
  .box {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>
